import React from 'react';
import {
  fields,
} from './clinicalInformationFieldsData';
import {
  clinicalInformationNoteJSX,
  clinicalInformationIsNotProvidedJSX,
  fieldsJSX,
  blockIdentificationKeyInfoJSX,
} from './clinicalInformationFieldsJSX';

const ClinicalInformationComponent = ({ clinicalInformationIsNotProvided, handleNotProvided }) => (
  <>
    {clinicalInformationNoteJSX()}
    {clinicalInformationIsNotProvidedJSX(clinicalInformationIsNotProvided, handleNotProvided)}
    {fieldsJSX(clinicalInformationIsNotProvided, fields)}
    {blockIdentificationKeyInfoJSX()}
  </>
);


export default ClinicalInformationComponent;
